var map = {
	"./AssessmentReport.svg": 331,
	"./Daily.svg": 332,
	"./EnrolledPatientReport.svg": 333,
	"./Failed.svg": 124,
	"./Ghana.svg": 334,
	"./Info-blue.svg": 213,
	"./Info-green.svg": 212,
	"./Kenya.svg": 335,
	"./MOH.svg": 336,
	"./Pending.svg": 214,
	"./Permanent.svg": 337,
	"./Presc.svg": 338,
	"./ScreenedReport.svg": 339,
	"./Sierra Leone.svg": 340,
	"./Tanzania.svg": 341,
	"./US.svg": 342,
	"./app-logo.svg": 72,
	"./arrow-right-small.svg": 343,
	"./assignQuickSightUser.svg": 344,
	"./avatar-o.svg": 345,
	"./bin.svg": 215,
	"./caret-down-grey.svg": 210,
	"./caret-down-white.svg": 346,
	"./checkbox-disabled.svg": 216,
	"./checkbox-empty.svg": 166,
	"./checkbox.svg": 167,
	"./close.svg": 217,
	"./download.svg": 125,
	"./dropdown.svg": 218,
	"./edit.svg": 126,
	"./hidePass.svg": 109,
	"./home.svg": 219,
	"./info-grey.svg": 347,
	"./info-orange.svg": 211,
	"./insights.svg": 348,
	"./no-icon.svg": 242,
	"./plus.svg": 220,
	"./power-switch.svg": 209,
	"./quickSightUser.svg": 349,
	"./reports.svg": 221,
	"./reset.svg": 222,
	"./search.svg": 223,
	"./send-disabled.svg": 168,
	"./send.svg": 224,
	"./showPass.svg": 79,
	"./success-blue.svg": 225,
	"./success-green.svg": 226,
	"./user-role-assigned.svg": 227,
	"./user-role-not-assigned.svg": 123,
	"./warning.svg": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;